<template>
    <div class="alert alert-danger" role="alert"> 
    Do not change the words {client_name}, {quotation_number}, {quotation_subject}, {sender_name} and {sender_mobile}. Because they will be replaced by the value needed. 
    </div> 
</template>